import { APP_EMITTER_EVENTS, AppEmitter, FormLabel, HiddenInputField } from "shared";
import { ITemplatePdfPasswordComponent } from "entities/template";
import React, { useEffect, useState } from "react";
import { ComponentTooltip, IComponentTooltipSettings } from "../component_tooltip/component_tooltip";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import { IValidationFunc } from "../../../../lib/types/validation";
import styles from "./document_form_pdf_password.module.scss";

interface IDocumentFormPdfPasswordProps {
    component: ITemplatePdfPasswordComponent;
    onChange: (tag: string, value?: string) => void;
    externalUpdateRecord: Record<string, any>;
    label?: string;
    tooltip: IComponentTooltipSettings;
    readonly: boolean;
    labelShort: boolean;
    triggerValidate: number;
    onValidationRegister: (validationFunc: IValidationFunc, tag: string) => void;
}

export const DocumentFormPdfPassword: React.FC<IDocumentFormPdfPasswordProps> = React.memo(({
                                                                                                component,
                                                                                                label,
                                                                                                readonly,
                                                                                                labelShort,
                                                                                                triggerValidate,
                                                                                                onValidationRegister,
                                                                                                externalUpdateRecord,
                                                                                                tooltip,
                                                                                                onChange,
                                                                                            }) => {
    const [value, setValue] = useState<string>();
    const { notRequiredPasswordValidation } = useComponentValidateFunction();

    useEffect(() => {
        AppEmitter.on(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        return () => {
            AppEmitter.off(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        }
    }, [])

    useEffect(() => {
        if (component.name) {
            onValidationRegister(validatePdfPassword, component.name);
        }
    }, [component.name, value])

    useEffect(() => {
        return () => {
            onValidationRegister(() => {
                return Promise.resolve(true)
            }, component.name);
            onChange(component.name, undefined);
        };
    }, []);

    useEffect(() => {
        onChange(component.name, value);
    }, [value]);

    useEffect(() => {
        if (component.name) {
            const val = externalUpdateRecord[component.name];
            setValue(val);
        }
    }, [externalUpdateRecord, component.name]);

    const validatePdfPassword = () => {
        if (value) {
            const valid = notRequiredPasswordValidation(value).valid;
            return Promise.resolve(valid);
        } else {
            return Promise.resolve(true);
        }
    }

    const handleClearEvent = () => {
        if (!readonly) {
            setValue(undefined);
        }
    };

    return component.name ? <FormLabel title={label} disabled={readonly} labelShort={labelShort}>
        <div className={styles.container}>
            <HiddenInputField
                validate={!!value}
                disabled={readonly}
                className={styles.input}
                value={value}
                name={component.name}
                triggerValidate={triggerValidate}
                validateFunc={notRequiredPasswordValidation}
                onChange={(v) => setValue(v)}
            />
            <ComponentTooltip tooltip={tooltip} id={component.id.toString()} className={styles.tooltip}/>
        </div>
    </FormLabel> : null;
});
